<template>
  <div id="app">
    <div class="notification is-secondary is-light has-text-centered" v-if="atr_docs_url" >
      API <a :href="atr_docs_url" target="_blank">documentation</a>
    </div>
    <a href="https://teklia.com"><img v-if="brand == 'teklia'" width="300px" alt="Teklia logo" src="https://assets.teklia.com/ocelus-demo/logo.png"></a>
    <h1 class="title is-1 has-text-grey-dark is-family-sans-serif">AI for Cultural Heritage Collections</h1>
    <p class="is-size-4 has-text-grey-dark is-family-sans-serif">Explore AI technologies selected by TEKLIA for the analysis and enrichment of cultural heritage documents</p>
    <p class="is-size-4 has-text-grey-dark is-family-sans-serif">TEKLIA surveys and benchmarks the full landscape of available models and selects the most effective solutions for cultural heritage, guided by our experience, internal evaluations, data confidentiality requirements, and resource efficiency</p>
    <p class="is-size-4 has-text-grey-dark is-family-sans-serif">You have a specific collection or challenge? <a href='https://teklia.com/company/contact/'>Contact us</a> to define the right AI strategy for your cultural heritage projects.</p>
    <hr />
    <router-view></router-view>
  </div>
</template>

<script>
import { BRAND, ATR_API_URL } from './main'

export default {
  name: 'App',
  data: () => ({
    brand: BRAND,
  }),
  computed: {
    atr_docs_url: () => {
      if ( ! ATR_API_URL ) {
        return null;
      }

      const url = new URL(ATR_API_URL);
      return url.origin;
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
